module.exports = __webpack_public_path__ + "static/media/sourcesanspro-italic-webfont.95366d5c.eot";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/sourcesanspro-italic-webfont.eot
// module id = 274
// module chunks = 0